import { Box, Divider, Drawer, IconButton } from '@mui/material'
import { Link } from 'react-router-dom'
import { ChevronLeftIcon, ChevronRightIcon } from '~components/icons'
import useBreakpoint from '~hooks/use-breakpoint'
import { OPEN_DRAWER_WIDTH } from '~hooks/use-nav-and-footer-constants'
import { MENU_Z_INDEX } from '../../navigation'
import {
  breakpointsWithHamburgerMenu,
  useNavigation,
} from '../../navigation-context'
import { usePrimaryMenuLinks } from '../hooks/use-primary-menu-links'
import { useSubheaderLinks } from '../hooks/use-subheader-links'
import { MenuItemsRenderer } from './menu-items-renderer'

const CLOSED_DRAWER_WIDTH_XL = '89px'

export function PrimaryLeftNavigation() {
  const {
    isOpen: isMenuOpen,
    setIsOpen: setIsMenuOpen,
    tourLink,
  } = useNavigation()
  const topLinks = usePrimaryMenuLinks()
  const bottomLinks = useSubheaderLinks()
  const { breakpoint } = useBreakpoint()
  const isHamburger = breakpointsWithHamburgerMenu.includes(breakpoint)

  const handleClose = () => {
    setIsMenuOpen(false)
  }

  return (
    <Drawer
      anchor={!isHamburger ? 'left' : 'top'}
      variant={isHamburger ? 'temporary' : 'permanent'}
      open={isMenuOpen}
      onClose={handleClose}
      // Guided tours spotlight menu links on open; Joyride does not re-measure
      // targets during the slide-in animation.
      transitionDuration={isHamburger && tourLink ? 0 : undefined}
      disableScrollLock
      slotProps={{
        paper: {
          className: 'tour-step-nav-pane',
          sx: getDrawerPaperStyles(isMenuOpen, isHamburger),
        },
      }}
    >
      {!isHamburger && (
        <>
          <DrawerHeader />
          <Divider />
        </>
      )}

      <MenuItemsRenderer topItems={topLinks} bottomItems={bottomLinks} />
    </Drawer>
  )
}

function getDrawerPaperStyles(open: boolean, isHamburger: boolean) {
  return open
    ? {
        mt: isHamburger ? '64px' : 0,
        zIndex: MENU_Z_INDEX,
        width: isHamburger ? '100%' : OPEN_DRAWER_WIDTH,
        transition: 'width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
        overflowX: 'hidden',
        backgroundColor: 'white !important',
      }
    : {
        mt: 0,
        zIndex: MENU_Z_INDEX,
        transition: 'width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
        overflowX: 'hidden',
        width: isHamburger ? '100%' : CLOSED_DRAWER_WIDTH_XL,
        backgroundColor: 'white !important',
      }
}

export function DrawerHeader() {
  const {
    isOpen: isMenuOpen,
    setIsOpen: setIsMenuOpen,
    navigationVariant,
  } = useNavigation()

  const handleDrawerOpen = () => {
    setIsMenuOpen(true)
  }
  const handleDrawerClose = () => {
    setIsMenuOpen(false)
  }

  return (
    <Box
      sx={{
        height: { xs: '64px', lg: '66px', xxxl: '84px' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: isMenuOpen ? 'start' : 'center',
      }}
    >
      {isMenuOpen ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            justifyContent: 'space-between',
            px: 2,
            ml: 2,
            width: '100%',
          }}
        >
          <Link to="/" style={{ height: 24 }}>
            {navigationVariant === 'primary' ? (
              <img
                src="/base-logo.svg"
                alt="Maersk Logo"
                style={{ width: '100%', height: 24 }}
              />
            ) : (
              <img
                src="/base-logo-dark.svg"
                alt="Maersk Logo"
                style={{ width: '100%', height: 24 }}
              />
            )}
          </Link>
          {navigationVariant !== 'secondary' && (
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon width="20px" height="20px" />
            </IconButton>
          )}
        </Box>
      ) : (
        <IconButton onClick={handleDrawerOpen}>
          <ChevronRightIcon width="20px" height="20px" />
        </IconButton>
      )}
    </Box>
  )
}
